import { route } from "../../../../application/domain/routing/named-route";
import { QualifiedInvoiceBusinessIssuersNew } from "./new";
import { QualifiedInvoiceBusinessIssuersEdit } from "./edit";

export const ServiceProviderQualifiedInvoiceRoutes = {
  QualifiedInvoiceBusinessIssuersNew: route({
    path: "/service-provider/orgs/:id/qualified-invoice/business-issuers/new",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/qualified-invoice/business-issuers/new`,
    component: QualifiedInvoiceBusinessIssuersNew,
  }),
  QualifiedInvoiceBusinessIssuersEdit: route({
    path: "/service-provider/orgs/:id/qualified-invoice/business-issuers/:businessIssuerId/edit",
    link: (args: { id: string; businessIssuerId: string }) =>
      `/service-provider/orgs/${args.id}/qualified-invoice/business-issuers/${args.businessIssuerId}/edit`,
    component: QualifiedInvoiceBusinessIssuersEdit,
  }),
};
